import { FC, PropsWithChildren } from 'react';
import { Panel } from '@cbridge-tools/resizable-panels';
import { MainContainer } from '../MainContainer/MainContainer';

export const MainPanel: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Panel id={'main'} style={{ height: '100%' }} tagName={'main'}>
      <MainContainer>
        {children}
      </MainContainer>
    </Panel>
  );
};
